import { createAsyncThunk } from "@reduxjs/toolkit";
import { commissionsAPI } from "libs/apiClient/Commissions";
import { commissionRolesAPI } from "libs/apiClient/CommissionRoles";
import { snackWrapper } from "helpers";

export const getCommission = createAsyncThunk(
	"stepOneSlice/getCommission",
	async (commissionId: number, { rejectWithValue }) => {
		try {
			return commissionsAPI.commissionsDetail(commissionId).then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getRoles = createAsyncThunk("stepOneSlice/getRoles", async (_, { rejectWithValue }) => {
	try {
		return commissionRolesAPI.listList().then((r) => r.data);
	} catch ({ message }) {
		return rejectWithValue(message);
	}
});

export const uploadDocx = createAsyncThunk(
	"stepOneSlice/uploadDocx",
	async (
		body: {
			docId: any;
			file: any;
			commissionId: any;
		},
		{ rejectWithValue, dispatch },
	) => {
		try {
			const params = new FormData();
			params.append("file", body.file);

			const res = commissionsAPI.docsUploadCreate(Number(body.docId), { ApprovedDoc: body.file });

			dispatch(getCommission(body.commissionId));
			snackWrapper("success", "Документ успешно загружен");

			return res;
		} catch ({ message }) {
			snackWrapper("error", "Ошибка загрузки документа");

			return rejectWithValue(message);
		}
	},
);
